import React from 'react';

// Theme context
export const ThemeContext  = React.createContext(null);
export const ThemeProvider = ThemeContext.Provider;

// keyframes tag
export const keyframes = () => {
};

// createGlobalStyle tag
export const createGlobalStyle = () => {
};

// css tag
export const css = require('./css');

// styled tag
const styled = () => {
};

export default styled;
